const paths = {
  listContract: '/contract/list',
  editContract: '/contract/edit',
  listContractVersions: '/contract/listVersions',
  consolidateContract: '/contract/consolidate'
};

export default paths;
